import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  requestGetCampaignByIdEffect,
  cancelCampaignExecEventEffect,
  retryCampaignExecEventEffect,
  requestGetCampaignUpcomingByCampaignIdEffect,
  requestGetCampaignPastByCampaignIdEffect,
  requestGetCampaignFailedByCampaignIdEffect,
  requestGetCampaignCanceledByCampaignIdEffect,
  requestGetCampaignOverdueByCampaignIdEffect,
} from 'store/effects/radarKits';
import { useParams } from 'react-router-dom';
import {
  CancelledDataType,
  FailedDataType,
  OverdueTaskType,
  PastDataType,
  UpcomingDataType,
  useCampaignClientExecInfo,
} from '../../AssignedClientsView/useCampaignClientExecInfo.hook';

export const useCampaignEvents = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const [upcomingData, setUpcomingData] = useState<any[]>([]);
  const [pastData, setPastData] = useState<any[]>([]);
  const [failedData, setFailedData] = useState<any[]>([]);
  const [canceledData, setCanceledData] = useState<any[]>([]);
  const [overDueData, setOverDueData] = useState<any[]>([]);
  const [campaign, setCampaign] = useState<any>(null);
  const [client, setClient] = useState<any>(null);
  const [isAddKitsModalOpen, setIsAddKitsModalOpen] = useState<boolean>(false);
  const [isReplyModelOpen, setIsReplyModelOpen] = useState<boolean>(false);
  const [replyRecord, setReplyRecord] = useState<any>(null);
  const handleOpenAddKitsModal = () => setIsAddKitsModalOpen(true);
  const handleCloseAddKitsModal = () => {
    fetchData();
    setIsAddKitsModalOpen(false);
  };

  const [cancelLoading, setCancelLoading] = useState<boolean>(false);
  const [retryLoading, setRetryLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState({
    upcoming: true,
    past: true,
    failed: true,
    canceled: true,
    overdue: true,
    campaign: true,
  });

  const fetchData = () => {
    setLoading({
      upcoming: true,
      past: true,
      failed: true,
      canceled: true,
      overdue: true,
      campaign: true,
    });
    dispatch(
      requestGetCampaignUpcomingByCampaignIdEffect(
        { id },
        { silent: !!upcomingData },
        (err, res) => {
          if (!err) setUpcomingData(res.data);
          setLoading((prev) => ({ ...prev, upcoming: false }));
        },
      ),
    );
    dispatch(
      requestGetCampaignPastByCampaignIdEffect({ id }, { silent: !!pastData }, (err, res) => {
        if (!err) setPastData(res.data);
        setLoading((prev) => ({ ...prev, past: false }));
      }),
    );
    dispatch(
      requestGetCampaignFailedByCampaignIdEffect({ id }, { silent: !!failedData }, (err, res) => {
        if (!err) setFailedData(res.data);
        setLoading((prev) => ({ ...prev, failed: false }));
      }),
    );
    dispatch(
      requestGetCampaignCanceledByCampaignIdEffect({ id }, { silent: true }, (err, res) => {
        if (!err) setCanceledData(res.data);
        setLoading((prev) => ({ ...prev, canceled: false }));
      }),
    );
    dispatch(
      requestGetCampaignOverdueByCampaignIdEffect({ id }, { silent: true }, (err, res) => {
        if (!err) setOverDueData(res.data);
        setLoading((prev) => ({ ...prev, overdue: false }));
      }),
    );
    dispatch(
      requestGetCampaignByIdEffect(id, { silent: true }, (err, res) => {
        if (!err) setCampaign(res.data.result);
        setLoading((prev) => ({ ...prev, campaign: false }));
      }),
    );
  };

  const refreshMemberData = useCallback(() => {
    setLoading((p) => ({
      ...p,
      upcoming: true,
      past: true,
      failed: true,
      canceled: true,
      overdue: true,
    }));
    dispatch(
      requestGetCampaignUpcomingByCampaignIdEffect(
        { id },
        { silent: !!upcomingData },
        (err, res) => {
          if (!err) setUpcomingData(res.data);
          setLoading((prev) => ({ ...prev, upcoming: false }));
        },
      ),
    );
    dispatch(
      requestGetCampaignPastByCampaignIdEffect({ id }, { silent: !!pastData }, (err, res) => {
        if (!err) setPastData(res.data);
        setLoading((prev) => ({ ...prev, past: false }));
      }),
    );
    dispatch(
      requestGetCampaignFailedByCampaignIdEffect({ id }, { silent: !!failedData }, (err, res) => {
        if (!err) setFailedData(res.data);
        setLoading((prev) => ({ ...prev, failed: false }));
      }),
    );
    dispatch(
      requestGetCampaignCanceledByCampaignIdEffect({ id }, { silent: true }, (err, res) => {
        if (!err) setCanceledData(res.data);
        setLoading((prev) => ({ ...prev, canceled: false }));
      }),
    );
    dispatch(
      requestGetCampaignOverdueByCampaignIdEffect({ id }, { silent: true }, (err, res) => {
        if (!err) setOverDueData(res.data);
        setLoading((prev) => ({ ...prev, overdue: false }));
      }),
    );
  }, [id, upcomingData, pastData, failedData, canceledData, overDueData]);

  useEffect(() => {
    fetchData();
  }, []);

  const cancelExecEvent = useCallback(
    async (execId, clientId) => {
      setCancelLoading(true);
      dispatch(
        cancelCampaignExecEventEffect(
          {
            CampaignId: id,
            MemberId: clientId,
            Id: execId,
          },
          { silent: true },
          (err, res) => {
            if (!err) {
              dispatch(
                requestGetCampaignFailedByCampaignIdEffect(
                  { id },
                  { silent: !!failedData },
                  (err, res) => {
                    if (!err) setFailedData(res.data);
                    setLoading((prev) => ({ ...prev, failed: false }));
                  },
                ),
              );
              dispatch(
                requestGetCampaignCanceledByCampaignIdEffect(
                  { id },
                  { silent: true },
                  (err, res) => {
                    if (!err) setCanceledData(res.data);
                    setLoading((prev) => ({ ...prev, canceled: false }));
                  },
                ),
              );
            }
            setCancelLoading(false);
          },
        ),
      );
    },
    [id],
  );

  const retryExecEvent = useCallback(
    async (execId, clientId) => {
      setRetryLoading(true);
      dispatch(
        retryCampaignExecEventEffect(
          {
            CampaignId: id,
            MemberId: clientId,
            Id: execId,
          },
          { silent: true },
          (err, res) => {
            if (!err) {
              dispatch(
                requestGetCampaignFailedByCampaignIdEffect(
                  { id },
                  { silent: !!failedData },
                  (err, res) => {
                    if (!err) setFailedData(res.data);
                    setLoading((prev) => ({ ...prev, failed: false }));
                  },
                ),
              );
              dispatch(
                requestGetCampaignPastByCampaignIdEffect(
                  { id },
                  { silent: !!pastData },
                  (err, res) => {
                    if (!err) setPastData(res.data);
                    setLoading((prev) => ({ ...prev, past: false }));
                  },
                ),
              );
            }
            setRetryLoading(false);
          },
        ),
      );
    },
    [id],
  );

  const openReplyModal = useCallback((record) => {
    setReplyRecord(record);
    setIsReplyModelOpen(true);
  }, []);

  const closeReplyModal = useCallback(() => {
    setReplyRecord(null);
    setIsReplyModelOpen(false);
  }, []);

  const { upcomingColumns, pastColumns, failedColumns, overdueColumns, canceledColumns } =
    useCampaignClientExecInfo({
      onCancel: cancelExecEvent,
      onRetry: retryExecEvent,
      onReplyClick: openReplyModal,
      isConsolidatedView: true,
    });

  const upcomingDataSource = useMemo<UpcomingDataType[]>(() => {
    return upcomingData.map((item) => {
      if (item.campaignKit) {
        return {
          key: item.campaignKit.Id,
          name: {
            title: item.campaignKit.Kit.Name,
            info: 'KIT',
          },
          assignee: item.assignee,
          scheduled: moment(item.execDate).format('MM/DD/YYYY'),
          clientInfo: item?.clientInfo,
        };
      } else {
        return {
          key: item.campaignTask.Id,
          name: {
            title: item.campaignTask.Title,
            info: 'Task',
          },
          assignee: item?.campaignTask?.AssigneeList?.[0]?.FirstName,
          scheduled: moment(item.execDate).format('MM/DD/YYYY'),
          clientInfo: item?.clientInfo,
        };
      }
    });
  }, [upcomingData]);

  const pastDataSource = useMemo<PastDataType[]>(() => {
    return pastData.map((item) => {
      if (item.campaignKit) {
        return {
          key: item.campaignKit.Id,
          name: {
            title: item.campaignKit.Kit.Name,
            info: 'KIT',
          },
          completed: {
            on: moment(item.execDate).format('MM/DD/YYYY'),
            by: item.assignee,
          },
          isOpened:
            item.opened && item.openedDate
              ? {
                  date: moment(item.openedDate).format('MM/DD/YYYY'),
                  time: moment(item.openedDate).format('h:mm A'),
                }
              : null,
          isClicked:
            item.clicked && item.clickedDate
              ? {
                  date: moment(item.clickedDate).format('MM/DD/YYYY'),
                  time: moment(item.clickedDate).format('h:mm A'),
                }
              : null,
          isReplied: item?.repliedDate
            ? {
                date: moment(item.repliedDate).format('MM/DD/YYYY'),
                time: moment(item.repliedDate).format('h:mm A'),
              }
            : null,
          replies: item.replies || [],
          clientInfo: item?.clientInfo,
        };
      } else {
        return {
          key: item.campaignTask.Id,
          name: {
            title: item.campaignTask.Title,
            info: 'Task',
          },
          completed: {
            on: moment(item.execDate).format('MM/DD/YYYY'),
            by: item?.campaignTask?.CompletedBy,
          },
          isOpened:
            item.opened && item.openedDate
              ? {
                  date: moment(item.openedDate).format('MM/DD/YYYY'),
                  time: moment(item.openedDate).format('h:mm A'),
                }
              : null,
          isClicked:
            item.clicked && item.clickedDate
              ? {
                  date: moment(item.clickedDate).format('MM/DD/YYYY'),
                  time: moment(item.clickedDate).format('h:mm A'),
                }
              : null,
          isReplied: item?.repliedDate
            ? {
                date: moment(item.repliedDate).format('MM/DD/YYYY'),
                time: moment(item.repliedDate).format('h:mm A'),
              }
            : null,
          replies: item.replies || [],
          clientInfo: item?.clientInfo,
        };
      }
    });
  }, [pastData]);

  const failedDataSource = useMemo<FailedDataType[]>(() => {
    return failedData.map((item) => {
      return {
        key: item.campaignKit.Id,
        name: {
          title: item.campaignKit.Kit.Name,
          info: 'KIT',
        },
        failed: moment(item.execDate).format('MM/DD/YYYY'),
        error: item.error,
        isRetryAble: item.isRetryAble,
        id: item.execId,
        clientId: item?.clientInfo?.Id || item.clientId,
        clientInfo: item?.clientInfo,
      };
    });
  }, [failedData]);

  const overdueDataSource = useMemo<OverdueTaskType[]>(() => {
    return overDueData.map((item) => {
      return {
        name: item.campaignTask.Title,
        assignee: `${item?.campaignTask?.AssigneeList?.[0]?.FirstName || ''} ${
          item?.campaignTask?.AssigneeList?.[0]?.LastName || ''
        }`,
        scheduled: moment(item?.campaignTask?.DueDate).format('MM/DD/YYYY'),
        clientInfo: item?.clientInfo,
      };
    });
  }, [overDueData]);

  const canceledDataSource = useMemo<CancelledDataType[]>(() => {
    return canceledData.map((item) => {
      return {
        name: item.campaignKit.Kit.Name,
        assignee: client ? `${client?.FirstName} ${client?.LastName}` : '',
        canceled: item.updatedDate ? moment.utc(item.updatedDate).format('MM/DD/YYYY') : '',
        clientInfo: item?.clientInfo,
      };
    });
  }, [canceledData, client]);

  return {
    // upcoming columns
    upcomingColumns,
    upcomingDataSource,
    // past columns
    pastColumns,
    pastDataSource,
    // failed columns
    failedColumns,
    failedDataSource,
    // overdue columns
    overdueColumns,
    overdueDataSource,
    // canceled columns
    canceledColumns,
    canceledDataSource,

    loading,
    refreshMemberData,
  };
};
